/**
 * Created by yixi on 5/10/16.
 *
 * 生成 csv 文件, 接收二维数组
 * [[1,3,],[41,41],[123,123]]
 *
 */

export default array => {
  let csvContent = 'data:text/csv;charset=utf-8,\uFEFF';
  array.forEach((infoArray, index) => {
    const content = [];
    infoArray.forEach(v => {
      if (typeof v === 'string') {
        const reg = /[ ，,]/g;
        v = v.replace(reg, '').replace(/_/, ' '); // 上一行代码把空格去掉了，这里为了保留日期格式的空格，用_再转回去
      }
      content.push(v);
    });
    const dataString = content.join(',');

    csvContent += index < array.length ? `${dataString}\n` : dataString;
  });
  return csvContent;
};
